import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import './AccessDenied.css';

const AccessDenied = () => {
    const navigate = useNavigate();

    return (
        <Box className="access-denied-container">
            <Paper className="access-denied-card">
                <LockIcon className="access-denied-icon" />
                <Typography variant="h4" gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    You don't have permission to access this page.
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    This page is restricted to administrators only.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/admin/hookah-flavors')}
                    sx={{ mt: 2 }}
                >
                    Go to Dashboard
                </Button>
            </Paper>
        </Box>
    );
};

export default AccessDenied;
